module.exports = __webpack_public_path__ + "img/stapler_hr.a019fda3.png";